import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { CloseIcon, IconButton, Modal, Typography } from "@parkschannel/ui";
import { useStream } from "../../PopularVideos/PopularVideoSection/StreamContext";
import { StreamPlayer } from "./StreamPlayer";
export const StreamModal = (param)=>{
    let { isOpen , setIsOpen  } = param;
    const stream = useStream();
    if (!stream) return null;
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        contentClassName: "max-w-6xl !p-0 h-screen lg:h-auto",
        exitButton: (onClose)=>/*#__PURE__*/ _jsx(IconButton, {
                icon: /*#__PURE__*/ _jsx(CloseIcon, {}),
                onClick: onClose,
                size: "sm",
                variant: "base",
                className: "text-neutral-700 text-xs bg-white hover:bg-neutral-50 drop-shadow-sm"
            }),
        children: /*#__PURE__*/ _jsxs("section", {
            className: "h-full relative",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "relative bg-gray-300 flex min-h-0",
                    children: /*#__PURE__*/ _jsx(StreamPlayer, {
                        uniquePlayerId: "stream-player",
                        options: {
                            aspectratio: "4:3"
                        },
                        stream: {
                            playlistItemIndex: stream.currentlyPlayingMediaSummary.index,
                            timestamp: stream.timestamp,
                            thumbnail: stream.currentlyPlayingMediaSummary.item.image,
                            playlist: stream.streamLink
                        }
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "p-2 lg:absolute lg:bottom-4 lg:left-4 lg:p-0",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "bodyXL",
                        className: "text-neutral-900 font-bold line-clamp-1 lg:max-w-[500px] lg:text-white",
                        children: stream.currentlyPlayingMediaSummary.item.title
                    })
                })
            ]
        })
    });
};
